module.exports = __webpack_public_path__ + "static/fowf-toshi-color-03c9d26fad5f22768fe9ddc6f8ea3594.jpg";